import { onReady } from "../../utils/events/onReady";
import { addEvent } from "../../utils/events/events";
import queryString from "query-string";
import moment from "moment";
export class Search {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined,

    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;
        onReady(() => this.init());
    }

    async fetchResult(data) {
        const endpoint = `https://andelskassen.ankiro.dk/Rest/andelskassen.dk/Search${data}`
        const response = await fetch(endpoint);
        const result = await response.json();
        this.createMarkup(result);
        result.Decorations.Pagination.TotalPages > 1 ? this.createPaginationMarkup(result.Decorations.Pagination) : null;
    }

    createPaginationMarkup(resp) {
        const { Pages } = resp;
        let cleanSearch = window.location.search;
        Pages.forEach(page => {
            cleanSearch = "";
            const pageElement = document.createElement("a");
            pageElement.href = `${page.Href}`;
            pageElement.setAttribute("aria-label", `${page.Label}`);
            pageElement.href === window.location.href ? pageElement.classList.add("current") : "";
            pageElement.innerText = page.Label;
            const paginationContainer = this.dom.container.querySelector(".search__results--pagination-container");
            paginationContainer.appendChild(pageElement);
        });
    }

    createMarkup(resp) {
        const queryParam = window.location.search;
        const searchTerm = this.dom.container.querySelector(".search__results--term");
        const searchResultsValue = this.dom.container.querySelector(".search__results--value");
        const articleContainer = this.dom.container.querySelector(".search__results--articles");
        searchTerm.textContent = queryString.parse(queryParam).q
        searchResultsValue.textContent = resp.TotalResults;
        const articles = resp.Documents.map((article, i) => {
            const { Properties } = article;
            const articleElement = document.createElement("article");
            let dictionary = Object.fromEntries(Properties.map(x => [x.Name, x]));
            articleElement.innerHTML = `
            <a href="https://andelskassen.ankiro.dk/Rest/Redir?url=${dictionary.Uri.Value}&searchId=${resp.SearchId}&documentId=${article.Id}&documentOffset=${article.LogicalOffset} ">
                <small>${moment(article.Created).calendar()}</small>
                <h4 class="link">${dictionary.Title.ValueMarkup}</h4>
                <p>${dictionary.Description.ValueMarkup}</p>
            </a>
            `;
            return articleElement;
        });
        articleContainer.append(...articles);
    }

    init() {
        const queryParam = window.location.search;
        this.fetchResult(queryParam);
    }
}
